import React, {useState} from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap';
import TextInput from '../../components/TextInput';
import { Controller, useForm } from 'react-hook-form';
import {getAllParticipants} from '../../services/participants';
import useModal from '../../hooks/useModal';
import GenericCard from '../../components/GenericCards/GenericCards';
import Link from '../../components/Link';
import IconButton from '../../components/IconButton';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
 
interface Participant {
  id: number;
  firstName: string;
  lastName: string;
  ssn: string;
}

const ParticipantAccess = () => {
  const {
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
    control,
 
    getValues
  } = useForm();

  const participantList = getAllParticipants();
  const [isLinkDisabled, setIsLinkDisabled] = useState(true);
  const [filteredParticipantList, setFilteredParticipantList] = useState<Participant[]>([]);
  const [isSearchResultVisible, setIsSearchResultVisible] = useState(false);

  
 
  const [
    showAddNewCaseModal,
    handleAddNewCaseShow,
    handleAddNewCaseClose,
  ] = useModal();

  const handleSearchButtonClick = () => {
    const { Name, SSN, EID, AccessID } = getValues(); // Get the search term from the form field

    if (!Name && !SSN) {
      // If search term is empty, display the full participant list
      setFilteredParticipantList(participantList);
      setIsSearchResultVisible(true);
    } else {
      // Filter the list based on the search term (both firstName and lastName)
      const filteredList = participantList.filter((participant: Participant) => {
        // Check if Name matches any part of the participant's name
        const nameMatches = !Name || Name.toLowerCase().split(" ").some((term: string) =>
          (participant.firstName.toLowerCase().includes(term) ||
          participant.lastName.toLowerCase().includes(term))
        );

        // Check if SSN matches the participant's SSN
        const ssnMatches = !SSN || participant.ssn.includes(SSN);

        return nameMatches && ssnMatches;
      });

      setFilteredParticipantList(filteredList);
      setIsSearchResultVisible(true);
    }
  };

  const handleResetButtonClick = () => {
    reset(); // Reset all form inputs
    setValue('SSN', '');
    setValue('EID', '');
    setValue('Name', '');
    setValue('AccessID', '')
    setValue('Inbox', null);
    setValue('with-labels', false); 
    setIsSearchResultVisible(false);
  };

  const maskSSNNumber = (recordNo: string) => {
    const maskedPartHead = '*'.repeat(recordNo.length - 6); // -7 to account for the 3 asterisks and 2 dashes
    const maskedPartMid = '*'.repeat(recordNo.length - 7);
    const lastFourDigits = recordNo.substring(recordNo.length - 4);
    return `${maskedPartHead}-${maskedPartMid}-${lastFourDigits}`;
  };

  const handleLinkClick = (e: { preventDefault: () => void; }) => {
    if (isLinkDisabled) {
      e.preventDefault(); // Prevent the default action
    }
  };
  
  const handleSubmitCase = (formData: any) => {
  };

  const [archiveValue, setArchiveValue] = React.useState<string[]>([]);


  return (
    <Container className={'cnd-custom-container px-0 mt-11'}>
      <Container className={'px-7 px-lg-0 mb-11 mb-lg-12'}>
        <Row>
          <Col className={'col-12 col-lg-12'}>
            <h2 className={'h2 text-sm-20-lg-24 mb-7 mb-lg-11'}>Participant Access</h2>
          </Col>
        </Row>
 
        <Row className="mt-8">
           <Col className="col-12 col-lg-7 p-2">

              <h5 className="text-sm-20-lg-24">Select Search Option <span className="text-fs-6 fw-light">(Only one option at a time)</span></h5>
              <Row className="mt-4">
              <Col className="col-12 p-1">
              <Controller
                name={'Name'}
                control={control}
                render={({ field }) => (
                  <TextInput
                    placeholder="Name"
                    isInvalid={!!errors.Name}
                    {...field}
                  />
                )}
              />
              {errors.Name && (
                <div className="error-message">
                  <span>{errors.Name.message}</span>
                </div>
              )}
              </Col>
             <Col className="col-12 p-1">
              <Controller
                name={'SSN'}
                control={control}
                render={({ field }) => (
                  <TextInput
                    placeholder="SSN"
                    isInvalid={!!errors.SSN}
                    {...field}
                  />
                )}
              />
              {errors.SSN && (
                <div className="error-message">
                  <span>{errors.SSN.message}</span>
                </div>
              )}
           </Col>
           <Col className="col-12 p-1">
            <Controller
              name={'EID'}
              control={control}
              render={({ field }) => (
                <TextInput
                  placeholder="EID"
                  isInvalid={!!errors.EID}
                  {...field}
                />
              )}
            />
            {errors.EID && (
              <div className="error-message">
                <span>{errors.EID.message}</span>
              </div>
            )}
          </Col>
          <Col className="col-12 p-1">
            <Controller
              name={'AccessID'}
              control={control}
              render={({ field }) => (
                <TextInput
                  placeholder="Access ID"
                  isInvalid={!!errors.AccessID}
                  {...field}
                />
              )}
            />
            {errors.Name && (
              <div className="error-message">
                <span>{errors.AccessID.message}</span>
              </div>
            )}
          </Col>
          </Row>
          </Col>
        <Col className="col-12 col-lg-5 p-1">
        
          <Row className={'m-0 p-0'}>
          <h5 className="text-sm-20-lg-24">At Your Fingertips</h5>
            <Col>
            <Container className="mt-3 p-10 border border-info rounded-1 col-lg-12">
              <Link rightIcon={light('chevron-right')}
                    className={'border-bottom py-4 '}
                    href="#/case-list"
                    isAlignAtEnd >
                      <h6 className="text-fs-6 mb-0 fw-normal  ">Case List</h6>
              </Link>
              <Link rightIcon={light('chevron-right')}
                    href="#/document-search"
                    isAlignAtEnd >
                      <h6 className="text-fs-6 mb-0 fw-normal ">Document Search</h6>
              </Link>
            </Container>
          </Col>
          </Row>
        </Col>
        </Row>

        <section className="py-11 py-lg-12 d-flex flex-column flex-lg-row">
          <Button
            className="mt-7 mt-lg-0 me-lg-7 order-2 order-lg-1 reset-button"
            variant="primary-outline"
            type="button"
            onMouseDown={handleResetButtonClick}
          >
            Reset
          </Button>
          <Button
            variant="primary"
            className="order-1 order-lg-2 search-button"
            type="button"
            onMouseDown={handleSearchButtonClick}
          >
            Search
          </Button>
        </section>
        {isSearchResultVisible && (
          <div>
            <GenericCard
              variant={'white'}
              className={'mt-5 case-search-result'}
            >
              <Container className={'px-0 py-0'}>
                <Row className={'mt-0 pb-5 border-bottom-light-gray-2px col'}>
                  <Col lg={8} className={'col-7'}>
                    <div className={'d-flex align-items-center  '}>
                      Name (Last, First)
                    </div>
                  </Col>

                  <Col lg={4} className={'col-5'}>
                    <div className={'d-flex align-items-center col-5'}>SSN</div>
                  </Col>
                </Row>
                {/* Table body */}
                {filteredParticipantList && filteredParticipantList.map((participantItem, index) => (
                    <Row className={'my-5 pb-5 border-bottom'}>
                      <Col lg={8} className={'col-7'}>
                        <div className={'d-flex align-items-center'}>
                          {participantItem.lastName},{' '}
                          {participantItem.firstName}
                        </div>
                      </Col>

                      <Col lg={4} className={'col-5'}>
                        <div className={'d-flex align-items-center'}>
                          <a
                            className={`text-decoration-none ${
                              isLinkDisabled ? 'disabled-link' : ''
                            }`}
                            >
                            {maskSSNNumber(participantItem.ssn)}
                          </a>
                        </div>
                      </Col>
                    </Row>
                  ))}
              </Container>
            </GenericCard>
          </div>
        )}
      </Container>
    </Container>
  );
}

export default ParticipantAccess